import { render, staticRenderFns } from "./ModuleGrid.vue?vue&type=template&id=41afb986&scoped=true&"
import script from "./ModuleGrid.vue?vue&type=script&lang=js&"
export * from "./ModuleGrid.vue?vue&type=script&lang=js&"
import style0 from "./ModuleGrid.vue?vue&type=style&index=0&id=41afb986&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41afb986",
  null
  
)

export default component.exports